import { Link } from "gatsby";
import React from "react";
import { Link as LinkScroll } from "react-scroll";
import { slug } from "../../../utils/slug";

const CustomLink = ({ data, cls }) => {
  const isHomePage =
    typeof window !== "undefined" && window.location.pathname === "/";

  if (data.linkType === "url") {
    return (
      <a
        className={cls}
        href={data.url}
        target={
          data.url?.includes("order.simplysalad.com") ? "_self" : "_blank"
        }
        rel="noopener noreferrer"
      >
        {data.menutitle}
      </a>
    );
  } else if (data.linkType === "id") {
    if (isHomePage) {
      return (
        <LinkScroll
          to={data.id}
          className={`${cls} cursor-pointer`}
          smooth
          duration={200}
          offset={-120}
        >
          {data.menutitle}
        </LinkScroll>
      );
    } else {
      return (
        <Link to={`/#${data.id}`} className={cls} activeClassName="active_link">
          {data.menutitle}
        </Link>
      );
    }
  } else if (data.linkType === "upload") {
    return (
      <a
        className={cls}
        href={data.pdf.asset.url}
        target={
          data.pdf.asset.url?.includes("order.simplysalad.com")
            ? "_self"
            : "_blank"
        }
        rel="noopener noreferrer"
      >
        {data.menutitle}
        <span className="normal-case"> (PDF)</span>
      </a>
    );
  } else {
    return (
      <Link
        to={slug(data.slug.current)}
        className={cls}
        activeClassName="active_link"
      >
        {data.menutitle}
      </Link>
    );
  }
};

export default CustomLink;
